'use client';

import { useEffect } from 'react';

export function TeamsProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Initialize Teams JS SDK — tells Teams the app loaded successfully
    // This prevents the "There was a problem reaching this app" timeout error
    import('@microsoft/teams-js').then(({ app }) => {
      app.initialize().then(() => {
        app.notifySuccess();
      }).catch(() => {
        // Not running inside Teams — ignore
      });
    }).catch(() => {
      // SDK not available — ignore
    });
  }, []);

  return <>{children}</>;
}
